import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import profileKey from "../../assets/images/profile/profileKey.png";
import { Config } from "../../Config";
import { useDispatch, useSelector } from "react-redux";
import { emptyCart, removeUser } from "../../Redux/Actions";
import { toast } from "react-toastify";
import "./ProfileChangeBasePassword.scss";

const ProfileChangeBasePassword = (props) => {
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [lastPassword, setLastPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const resetPasswordHandler = (event, btn) => {
    event.preventDefault();
    if (lastPassword === "" || newPassword === "" || confirmNewPassword === "") {
      toast.error("لطفا فیلد های خالی را پر کنید");
      return;
    }
    if (newPassword.length < 6 || confirmNewPassword.length < 6) {
      toast.error("کلمه عبور باید حداقل شامل 6 کاراکتر باشد");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      toast.error("کلمه عبور جدید و تکرار کلمه عبور جدید یکی نیستند!");
    } else {
      btn.target.classList.add("blurInput");
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);
      var raw = JSON.stringify({
        OldPassword: lastPassword,
        Password: newPassword,
        PasswordConfirm: confirmNewPassword,
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(Config.apiPath + "/Account/ChangePassword", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            btn.target.classList.remove("blurInput");
            toast.success(<div>{result.messages}</div>);
            if (dispatch(removeUser(user[0]))) {
              dispatch(emptyCart(cart));
              document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
            }
            setTimeout(() => {
              props.history.push("/login");
            }, 5000);
          } else {
            btn.target.classList.remove("blurInput");
            toast.error(<div>{result.messages}</div>);
          }
        })
        .catch((error) => {
          btn.target.classList.remove("blurInput");
          // console.log(error);
        });
    }
  };
  return (
    <div className="ProfileChangeBasePassword">
      <div className="formWrapper">
        <span className="formHeader">تغییر کلمه عبور ثابت</span>
        <div className="formInput lastPassword">
          <label className="formLabel">کلمه عبور قبلی</label>
          <input
            className="input"
            type="password"
            value={lastPassword}
            onChange={(e) => {
              setLastPassword(e.target.value.replace(" ", ""));
            }}
          />
        </div>
        <div className="formInput">
          <label className="formLabel">کلمه عبور</label>
          <input
            className="input"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value.replace(" ", ""))}
          />
        </div>
        <div className="formInput">
          <label className="formLabel">تکرار کلمه عبور</label>
          <input
            className="input"
            type="password"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value.replace(" ", ""))}
          />
        </div>
        <button className="submit" onClick={(e) => resetPasswordHandler(e, e)}>
          ثبت
        </button>
      </div>
      <div className="imagFigure">
        <img src={profileKey} alt="profileKey" />
      </div>
    </div>
  );
};

export default React.memo(withRouter(ProfileChangeBasePassword));
